import { API_ROUTES } from "../constants/apiRoutes";
import { axiosClient } from "./axios";

export interface LoginEmailResponse {
  message: string;
  code: string;
}

export interface LoginInAppResponse {
  message: string;
  code: string;
}

export const openLogin = () => {
  const authUrl = `${axiosClient.defaults.baseURL}${API_ROUTES.GOOGLE_LOGIN}`;
  window.location.href = authUrl;
};

export const sendSMSEmail = async (
  email: string,
): Promise<LoginEmailResponse> => {
  const res = await axiosClient.post(`${API_ROUTES.SMS_EMAIL}`, {
    user: email,
    type: "email",
  });
  return res.data;
};

export const confirmOTPEmail = async (
  email: string,
  otp: string,
): Promise<LoginEmailResponse> => {
  const res = await axiosClient.post(`${API_ROUTES.CONFIRM_EMAIL}`, {
    email: email,
    otp: otp,
  });
  return res.data;
};

export const inAppLogin = async (accountId: string): Promise<void> => {
  const res = await axiosClient.get(`${API_ROUTES.INAPP_LOGIN}/${accountId}`);
  window.location.href = res.data?.callback;
};
